var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"small"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})]),_c('ckeditor',{staticClass:"editor",attrs:{"editor":_vm.editor,"config":_vm.editorConfig},on:{"input":_vm.handleInput},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }